
<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0 ;  height: 100%">
        <van-cell-group>
            <van-cell title="秩序册信息" @click="goto(1)" is-link>
                <van-tag v-if="pageData.confirm_1==2" type="danger">待确认</van-tag>
                <van-tag v-else plain type="success">已确认</van-tag>
            </van-cell>
            <van-cell title="项目信息" @click="goto(2)" is-link>
                <van-tag v-if="pageData.confirm_2==2" type="danger">待确认</van-tag>
                <van-tag v-else plain type="success">已确认</van-tag>
            </van-cell>
            <van-cell title="食宿信息" v-if="pageData.need_shisu==1" @click="goto(3)" is-link>
                <van-tag v-if="pageData.confirm_3==2" type="danger">待确认</van-tag>
                <van-tag v-else plain type="success">已确认</van-tag>
            </van-cell>
            <van-cell title="到达酒店时间" v-if="pageData.need_shisu==1&&pageData.trans_station_setting" @click="goto(4)" is-link>
                <van-tag v-if="pageData.confirm_4==2" type="danger">完善到达酒店时间</van-tag>
                <van-tag v-else-if="pageData.confirm_4==3" type="danger">待确认</van-tag>
                <van-tag v-else-if="pageData.confirm_4==1" plain type="success">已确认</van-tag>
                <van-tag v-else plain >不需要</van-tag>
            </van-cell>
            <van-cell title="离开酒店时间" v-if="pageData.need_shisu==1&&pageData.trans_station_setting" @click="goto(5)" is-link>
                <van-tag v-if="pageData.confirm_5==2" type="danger">完善离开酒店时间</van-tag>
                <van-tag v-else-if="pageData.confirm_5==3" type="danger">待确认</van-tag>
                <van-tag v-else-if="pageData.confirm_5==1" plain type="success">已确认</van-tag>
                <van-tag v-else plain >不需要</van-tag>
            </van-cell>
            <van-cell title="用餐信息" v-if="pageData.need_shisu==1" @click="goto(6)" is-link>
            </van-cell>
            <van-cell title="看台啦啦操报名" v-if="pageData.kantaibaoming_url" @click="ktllc()" is-link>
            </van-cell>

        </van-cell-group>
        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />

    </div>
</template>

<style scoped="">
</style>
<script>
    import LoginDialog from '@/components/LoginDialog.vue';

    import {
            Cell, CellGroup,Tag
    } from 'vant';
    export default {
        name: 'saiConfirm',
        components: {
            [Cell.name]: Cell,
            [Tag.name]: Tag,
            [CellGroup.name]: CellGroup,
            LoginDialog
        },
        data: function () {
            return {

                loginShow:false,
                pageData:{
                    'id' : this.$route.query.id,
                    'name' :'',
                    'face' :'',
                    'phone' :'',
                }
            }
        },
        mounted: function () {
            document.title = "信息确认";
            let that = this;
            this.fetch();
        },
        methods: {
            fetch(){
                let that = this;
                this.$api.get('/api/sai/confirmdetail', {
                    id:that.pageData.id
                }, r => {
                    this.pageData = r.data;
                },(res) =>{
                    console.log('没有登录');
                    if (res.code == 401 || res.code==402) {
                        if(window.isApp()){
                            rbLink({
                                name:'login','query':{ }
                            },'replace');
                            return false;
                        }
                        that.loginShow = true
                    }else {
                        Toast(res.msg)
                    }
                });
            },
            goto:function (type) {
                let that = this;
                if((type==4 ) && that.pageData.confirm_4==4) return ;
                if((type==5 ) && that.pageData.confirm_5==4) return ;
                switch (type){
                    case 6 :
                        that.$router.push({'name':'saiConfirmDetailDinner','query':{'id':that.pageData.id,'type':type}});
                        break;
                    default : that.$router.push({'name':'saiConfirmDetail'+type,'query':{'id':that.pageData.id,'type':type}});
                }

            },
            ktllc(){
                location.href=this.pageData.kantaibaoming_url
            },

            loginSuccess(res){
                console.log('-------登录成功--------',res);
                this.loginShow = false;
                this.fetch();
            },

            loginCancel(){
                console.log('-------取消登录--------');
                // this.loginShow = false;
            },
        }
    }
</script>


// WEBPACK FOOTER //
// saiConfirm.vue?1b986022